import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import Footer from "../../components/molecules/footer/Footer";
import Header from "../../components/molecules/header/Header";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ConstantesTabla from "../../utils/ConstantesTabla";
import DataTable from "react-data-table-component";
import { getDatosIhPersona } from "../../components/services/IhPersonaService";
import { getDatosPerProRestantes18 } from "../../components/services/DatoPersonalService";

const SolicitudReconServiciosPrevios = () => {
  const params = useParams();
  const fechaHoy = new Date();
  const optionsVinculo = [
    { value: "C", label: "Funcionario de Carrera" },
    { value: "P", label: "En Prácticas" },
    { value: "E", label: "Interino" },
    { value: "LF", label: "laboral fijo" },
    { value: "LT", label: "Laboral Temporal" },
    { value: "A", label: "Contratado Administrativo" }
  ]
  const opcionesFecha = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  const formatoFecha = new Intl.DateTimeFormat('es-ES', opcionesFecha);
  const fechaFormateada = formatoFecha.format(fechaHoy).replace(/de/g, '').replace(/(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/g, (match) => match.charAt(0).toUpperCase() + match.slice(1));
  const [datosIniciales, setDatosIniciales] = useState({
    nombreBorrador: "", // WESOLACTADM.NOMBRE

    datosPerPro: {
      dni: "",
      apellido1: "",
      apellido2: "",
      nombre: "",
      cuerpoEscalaCatPro: "",
      sitAdmin: "",
      consejeria: "",
      localidad: "",
      puesto: ""
    },
    caracServicios: [{
      organismo: "", //wesrvprv.organismo
      vinculo: "",
      cuerpoEscalaCatPro: "", //wesrvprv.cap_c_catper
      grupo: "", //wesrvprv.grp_c_grupo
      fechaDesde: "", //wesrvprv.f_desde
      fechaHasta: "", //wesrvprv.f_hasta
    }],
    notificacionesyotrascomunicaciones: {
      domicilio: "",
      codigopostal: "",
      municipio: "",
      provincia: "",
      correo: "",
      tlfPart: ""
    },
    firmaSol: {
      dprovinciafirma: ""
    }

  })
  const navigate = useNavigate();
  const [loading] = useState(true); // cambiar
  const [setShow] = useState({
    mensaje: false,
    modalPresentar: false,
  });

  const emptyRowTemplate = {
    organismo: "",
    vinculo: "",
    cuerpoEscalaCatPro: "",
    grupo: "",
    fechaDesde: "",
    fechaHasta: "",
  };
  const totalFilas = 12;
  const serviciosConFilasVacias = [
    ...datosIniciales.caracServicios,
    ...Array.from({ length: totalFilas }, () => ({ ...emptyRowTemplate }))
  ];

  const columnasServiciosPrevios = [
    {
      name: "Organismos donde se prestaron",
      cell: (row, index, column, id) => (
        <Field
          name={`caracServicios[${index}].organismo`}
          className="form-control"
          type="text"
        />
      ),
      grow: 2,
    },
    {
      name: "Vínculo",
      cell: (row, index) => (
        // <Field
        //   name={`caracServicios[${index}].vinculo`}
        //   className="form-control"
        //   type="text"
        // />
        <Field
          as="select"
          id="vinculo"
          name={`caracServicios[${index}].vinculo`}
          className="form-select"
        // defaultValue={
        //   datos?.dtipvia
        //     ? datos?.dtipvia
        //     : ""
        // }
        // value={undefined}
        >
          <option value="" disabled >
            Elige...
          </option>
          {/* {} */}

          {optionsVinculo.map((tipo, i) => (
            <option value={tipo.value} key={i}>
              {tipo.value}
            </option>
          ))}
        </Field>
      ),
      grow: 1,
    },
    {
      name: "Cuerpo/Escala o Categoría Profesional",
      cell: (row, index) => (
        <Field
          name={`caracServicios[${index}].cuerpoEscalaCatPro`}
          className="form-control"
          type="text"
        />
      ),
      grow: 2,
    },
    {
      name: "Grupo/Subgrupo",
      cell: (row, index) => (
        <Field
          name={`caracServicios[${index}].grupo`}
          className="form-control"
          type="text"
        />
      ),
      grow: 1,
    },
    {
      name: "Fecha Desde",
      cell: (row, index) => (
        <Field
          name={`caracServicios[${index}].fechaDesde`}
          className="form-control"
          type="date"
        />
      ),
      grow: 1,
    },
    {
      name: "Fecha Hasta",
      cell: (row, index) => (
        <Field
          name={`caracServicios[${index}].fechaHasta`}
          className="form-control"
          type="date"
        />
      ),
      grow: 1,
    },
  ];

  useEffect(() => {
    // if (!params?.id) {
    getDatosIhPersona().then((data) => {
      

      setDatosIniciales((prev) => ({
        ...prev,
        datosPerPro: {
          ...prev.datosPerPro,
          dni: data?.niep || "",
          apellido1: data?.apellido1 || "",
          apellido2: data?.apellido2 || "",
          nombre: data?.nombre || "",
          cuerpoEscalaCatPro: data?.cuerpoEscalaCatPro || "",
          sitAdmin: data?.sitAdmin || "",
          consejeria: data?.consejeria || "",
          localidad: data?.locclocalidad || "",
          puesto: data?.puesto || ""
        },
        notificacionesyotrascomunicaciones: {
          ...prev.notificacionesyotrascomunicaciones,
          domicilio: data?.dcalle || "",
          codigopostal: data?.cpostal || "",
          municipio: data?.locmuncmunicipio || "",
          provincia: data?.locmunprvcprodom || "",
          correo: data?.cemailper || "",
          tlfPart: data?.ntelefono || ""
        }
      }));
      getDatosPerProRestantes18(data?.xpersona,"18").then((data) => {
        setDatosIniciales((prev) => ({
          ...prev,
          datosPerPro: {
            ...prev.datosPerPro,
            cuerpoEscalaCatPro: data?.cuerpoEscalaCatPro || "",
            sitAdmin: data?.sitAdmin || "",
            consejeria: data?.consejeria || "",
            puesto: data?.puesto || ""
          }

        }));
      })
    });


    // 

    // }
  }, [params]);

  return (<>
    <Header />
    <div className="container d-flex flex-column card mt-5" id="inicio" role="main" data-landmark-index="4">
      {loading ? (<>
        <Formik
          enableReinitialize
          initialValues={{
            nombreBorrador: datosIniciales?.nombreBorrador
              ? datosIniciales.nombreBorrador
              : `Borrador ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              })}`,
            datosPerPro: {
              dni: datosIniciales.datosPerPro?.dni || "",
              apellido1: datosIniciales.datosPerPro?.apellido1 || "",
              apellido2: datosIniciales.datosPerPro?.apellido2 || "",
              nombre: datosIniciales.datosPerPro?.nombre || "",
              cuerpoEscalaCatPro: datosIniciales.datosPerPro?.cuerpoEscalaCatPro || "",
              sitAdmin: datosIniciales.datosPerPro?.sitAdmin || "",
              consejeria: datosIniciales.datosPerPro?.consejeria || "",
              localidad: datosIniciales.datosPerPro?.localidad || "",
              puesto: datosIniciales.datosPerPro?.puesto || ""
            },
            caracServicios: serviciosConFilasVacias,
            notificacionesyotrascomunicaciones: {
              domicilio: datosIniciales.notificacionesyotrascomunicaciones?.domicilio || "",
              codigopostal: datosIniciales.notificacionesyotrascomunicaciones?.codigopostal || "",
              municipio: datosIniciales.notificacionesyotrascomunicaciones?.municipio || "",
              provincia: datosIniciales.notificacionesyotrascomunicaciones?.provincia || "",
              correo: datosIniciales.notificacionesyotrascomunicaciones?.correo || "",
              tlfPart: datosIniciales.notificacionesyotrascomunicaciones?.tlfPart || ""
            },
            firmaSol: {
              dprovinciafirma: datosIniciales.firmaSol?.dprovinciafirma || ""
            }
          }}
          onSubmit={(values) => {
            // Opción: limpiar filas vacías antes de enviar
            // const serviciosFiltrados = values.caracServicios.filter(servicio =>
            //   servicio.organismo || servicio.vinculo || servicio.cuerpoEscalaCatPro ||
            //   servicio.grupo || servicio.fechaDesde || servicio.fechaHasta
            // );

            // const datosFinales = {
            //   ...values,
            //   caracServicios: serviciosFiltrados
            // };

            
            // aquí podrías hacer setDatosIniciales(datosFinales) si lo necesitas
          }}
        >
          {({ errors, values }) => (
            <>
              <Form>
                <>
                  <div className="my-auto formularioSolReconPrevios">
                    <div className="tituloSoj d-flex align-items-center flex-column">
                      <h2 className="tituloPagina">Acto 18 </h2>
                      <h2 className="tituloPagina m-2">Solicitud reconocimiento de Servicios Previos  al personal funcionario (de carrera o interino) y al personal laboral fijo</h2>
                      <p className="text-third-1">{datosIniciales.estado}</p>
                    </div>
                    <div className="infoSolicitud">
                      <div className="instrucciones my-3 mx-2 fw-bold">


                        <div className="d-flex flex-row">
                          Antes de cumplimentar y enviar esta solicitud, deberá leer las instrucciones pinchando{" "}
                          <div

                            className="ps-1 verde cursorPointer underline bg-transparent border-none p-0"
                            onClick={() => {
                              window.open("/instruccionesSolicitudpopup", "popupInstrucciones", "width=800,height=600,resizable=yes,scrollbars=yes");
                            }}
                          >
                            aquí
                          </div>
                        </div>



                      </div>

                      <p className="textoInfo p-2">
                        Al amparo de lo previsto en la Ley 70/1978, de 26 de diciembre, en el Real Decreto 1461/1982, de 25 de junio, en el Real Decreto
                        Legislativo 5/2015, de 30 de octubre, por el que se aprueba el texto refundido de la Ley del Estatuto Básico del Empleado Público
                        y en el V Convenio Colectivo para el Personal Laboral al servicio de la Junta de Extremadura, el funcionario (de carrera,
                        interino) o laboral fijo, cuyos datos personales y profesionales se expresan a continuación, solicita el reconocimiento, a efectos de
                        trienios o de complemento de antigüedad, de los servicios prestados en Ia Administración que seguidamente se indican,
                        acreditando con el Anexo I, sólo los prestados en otras administraciones públicas, SES o Personal Docente.
                      </p>
                    </div>
                    <div className="formulario">
                      <div className="nombreBorrador row mx-3">
                        <label htmlFor="nombreBorrador">
                          Nombre Borrador{" "}
                          <span className="rojo">*</span>:
                        </label>
                        <Field
                          type="text"
                          id="nombreBorrador"
                          name="nombreBorrador"
                          className="form-control col-12"
                        />
                        <ErrorMessage
                          name="nombreBorrador"
                          component={() => (
                            <div className="error rojo pt-2">
                              {errors.nombreBorrador}
                            </div>
                          )}
                        />
                        <p className="p-3 text-third-1 d-flex justify-content-end">
                          Campo obligatorio *
                        </p>
                      </div>

                      <div className="datosPerPro">
                        <div className="d-flex justify-content-between">
                          <h3 className="tituloPagina">1. Datos personales y profesionales</h3>
                        </div>
                        <div className="row mx-2 mt-2">
                          <div className="dniDP col-md-3">
                            <label htmlFor="dni">DNI:</label>
                            <Field
                              type="text"
                              id="dni"
                              name="datosPerPro.dni"
                              className="form-control"
                              placeholder="DNI *"
                              readOnly
                              disabled
                            />
                            <ErrorMessage
                              name="dni"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.dni}
                                </div>
                              )}
                            />
                          </div>
                          <div className="ape1Actos  col-md-3">
                            <label htmlFor="apellido1">
                              Primer Apellido:
                            </label>
                            <Field
                              type="text"
                              id="apellido1"
                              name="datosPerPro.apellido1"
                              className="form-control"
                              readOnly
                              disabled
                            />
                          </div>
                          <div className="ape2Actos col-md-3  ">
                            <label htmlFor="apellido2">
                              Segundo Apellido:
                            </label>
                            <Field
                              type="text"
                              id="apellido2"
                              name="datosPerPro.apellido2"
                              className="form-control"
                              readOnly
                              disabled
                            />
                          </div>
                          <div className="nombreDP col-md-3">
                            <label htmlFor="nombre">Nombre:</label>
                            <Field
                              type="text"
                              id="nombre"
                              name="datosPerPro.nombre"
                              className="form-control"
                              placeholder="Nombre *"
                              readOnly
                              disabled
                            />
                            <ErrorMessage
                              name="nombre"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.nombre}
                                </div>
                              )}
                            />
                          </div>
                        </div>

                        <div className="row mx-2 mt-2">
                          <div className="cuerpoEscalaCatProDP col-md-6">
                            <label htmlFor="cuerpoEscalaCatPro">Cuerpo/Escala o Categoría Profesional a la que pertenece:</label>
                            <Field
                              type="text"
                              id="cuerpoEscalaCatPro"
                              name="datosPerPro.cuerpoEscalaCatPro"
                              className="form-control"
                              placeholder=""
                              readOnly
                              disabled
                            />
                            <ErrorMessage
                              name="cuerpoEscalaCatPro"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.cuerpoEscalaCatPro}
                                </div>
                              )}
                            />
                          </div>
                          <div className="sitAdminDP col-md-6">
                            <label htmlFor="sitAdmin">Situación administrativa:</label>
                            <Field
                              type="text"
                              id="sitAdmin"
                              name="datosPerPro.sitAdmin"
                              className="form-control"
                              placeholder="Nombre *"
                              readOnly
                              disabled
                            />
                            <ErrorMessage
                              name="sitAdmin"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.sitAdmin}
                                </div>
                              )}
                            />
                          </div>
                        </div>

                        <div className="row mx-2 mt-3">
                          <div className="consejeriaDP col-md-4">
                            <label htmlFor="nombre">Destino actual (Consejería):</label>
                            <Field
                              type="text"
                              id="consejeria"
                              name="datosPerPro.consejeria"
                              className="form-control"
                              placeholder=""
                              readOnly
                              disabled
                            />
                            <ErrorMessage
                              name="consejeria"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.consejeria}
                                </div>
                              )}
                            />
                          </div>
                          <div className="localidadDP col-md-4">
                            <label htmlFor="localidad">Localidad:</label>
                            <Field
                              type="text"
                              id="localidad"
                              name="datosPerPro.localidad"
                              className="form-control"
                              placeholder=""
                              readOnly
                              disabled
                            />
                            <ErrorMessage
                              name="localidad"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.localidad}
                                </div>
                              )}
                            />
                          </div>
                          <div className="puestoDP col-md-4">
                            <label htmlFor="puesto">Puesto de trabajo:</label>
                            <Field
                              type="text"
                              id="puesto"
                              name="datosPerPro.puesto"
                              className="form-control"
                              placeholder=""
                              readOnly
                              disabled
                            />
                            <ErrorMessage
                              name="puesto"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.puesto}
                                </div>
                              )}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="caracServicios mt-5">
                        <div className="d-flex justify-content-between">
                          <h3 className="tituloPagina">2. Características de los servicios cuyo reconocimiento se pretende (Por orden cronológico)</h3>
                        </div>
                        <FieldArray name="caracServicios">
                          {({ push, remove, form }) => (
                            <>
                              <div className="tablaServicios mt-5 mx-3">
                                <DataTable
                                  className="table-responsive"
                                  columns={columnasServiciosPrevios}
                                  data={form.values.caracServicios}
                                  noDataComponent={<span>No se encontró ningún servicio</span>}
                                  customStyles={ConstantesTabla.customStyles}
                                />
                              </div>

                              <div className="d-flex justify-content-end gap-2 mt-3">
                                <button
                                  type="button"
                                  className="btn btn-success"
                                  onClick={() =>
                                    push({
                                      organismo: "",
                                      vinculo: "",
                                      cuerpoEscalaCatPro: "",
                                      grupo: "",
                                      fechaDesde: "",
                                      fechaHasta: "",
                                    })
                                  }
                                >
                                  + Añadir
                                </button>

                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={() => {
                                    if (form.values.caracServicios.length > 1) {
                                      remove(form.values.caracServicios.length - 1);
                                    }
                                  }}
                                >
                                  - Quitar
                                </button>
                              </div>
                            </>
                          )}
                        </FieldArray>
                      </div>

                      <div className="notificacionesyotrascomunicaciones mt-5">
                        <div className="d-flex justify-content-between">
                          <h3 className="tituloPagina">3. Datos relativos a las notificaciones y otras comunicaciones (A efectos de que se me puedan practicar las notificaciones oportunas, señalo el siguiente domicilio)</h3>
                        </div>
                        <div className="row mx-2 mt-2">
                          <div className="domicilioDP col">
                            <label htmlFor="domicilio">Domicilio (calle,número,piso...):</label>
                            <Field
                              type="text"
                              id="domicilio"
                              name="notificacionesyotrascomunicaciones.domicilio"
                              className="form-control"
                              placeholder=""
                            />
                            <ErrorMessage
                              name="domicilio"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.domicilio}
                                </div>
                              )}
                            />
                          </div>
                        </div>

                        <div className="row mx-2 mt-2">
                          <div className="codigopostalDP col-md-4">
                            <label htmlFor="codigopostal">Código Postal:</label>
                            <Field
                              type="text"
                              id="codigopostal"
                              name="notificacionesyotrascomunicaciones.codigopostal"
                              className="form-control"
                              placeholder=""
                            />
                            <ErrorMessage
                              name="codigopostal"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.codigopostal}
                                </div>
                              )}
                            />
                          </div>
                          <div className="municipioDP col-md-4">
                            <label htmlFor="municipio">Municipio:</label>
                            <Field
                              type="text"
                              id="municipio"
                              name="notificacionesyotrascomunicaciones.municipio"
                              className="form-control"
                              placeholder=""
                            />
                            <ErrorMessage
                              name="municipio"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.municipio}
                                </div>
                              )}
                            />
                          </div>
                          <div className="provinciaDP col-md-4">
                            <label htmlFor="provincia">Provincia:</label>
                            <Field
                              type="text"
                              id="provincia"
                              name="notificacionesyotrascomunicaciones.provincia"
                              className="form-control"
                              placeholder=""
                            />
                            <ErrorMessage
                              name="provincia"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.provincia}
                                </div>
                              )}
                            />
                          </div>
                        </div>

                        <div className="row mx-2 mt-3">
                          <div className="tlfPartDP col-md-4">
                            <label htmlFor="tlfPart">Telefono particular contacto:</label>
                            <Field
                              type="text"
                              id="tlfPart"
                              name="notificacionesyotrascomunicaciones.tlfPart"
                              className="form-control"
                              placeholder=""
                            />
                            <ErrorMessage
                              name="tlfPart"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.tlfPart}
                                </div>
                              )}
                            />
                          </div>
                          <div className="correoDP col-md-8">
                            <label htmlFor="correo">Correo electrónico:</label>
                            <Field
                              type="text"
                              id="correo"
                              name="notificacionesyotrascomunicaciones.correo"
                              className="form-control"
                              placeholder=""
                            />
                            <ErrorMessage
                              name="correo"
                              component={() => (
                                <div className="error rojo pt-2">
                                  {errors.correo}
                                </div>
                              )}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="firmaSol mt-5">
                        <div className="d-flex justify-content-between">
                          <h3 className="tituloPagina">4. Declaración, lugar, fecha y firma de la solicitud</h3>
                        </div>
                        <div className="seccionFirma row mx-2 mt-2">
                          <div className="">
                            <p>La persona interesada, declara, bajo su expresa responsabilidad, la veracidad de los datos contenidos en la presente solicitud, quedando exonerada la
                              Administración de la Comunidad Autónoma de Extremadura de cualquier responsabilidad derivada de los errores u omisiones de los mismos.</p>
                          </div>
                          <div className="row d-flex justify-content-center align-items-center mb-5">
                            <p className="col-1 text-end mt-3">En </p>
                            <div className="lugarFirma col-3">
                              <Field
                                type="text"
                                id="dprovinciafirma"
                                name="lugarFirma.dprovinciafirma"
                                className="form-control"
                              // defaultValue={datos?.dprovinciafirma === null ? "" : datos?.dprovinciafirma}
                              />
                            </div>

                            <p className="col-3 mt-3">, a {fechaFormateada}</p>
                          </div>
                          <div className="">
                            <p>ACEPTO Y DOY MI CONSENTIMIENTO expreso al firmar la presente solicitud para que sean tratados los datos personales de la misma con la única
                              finalidad de que sean reconocidos los servicios previos prestados en la Administración a efectos de los trienios o de los complementos de antigüedad
                              que como personal funcionario (de carrera, interino) o laboral fijo, respectivamente, puedan corresponderme.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>





                <div className="d-grid justify-content-center">
                  <button
                    id="guardarSolicitudCarrera"
                    className="btnRed rounded btnCancelar px-4"
                    type="button"
                    // onClick={() =>
                    //   setShow({
                    //     mensaje: true,
                    //     content:
                    //       "¿Deseas cancelar el formulario?",
                    //     tipo: "tituloModal",
                    //     aviso: true,
                    //     destinoAviso: "/variacionDatosPersonales",
                    //     destinoCerrar: null,
                    //   })
                    // }
                    onClick={() => navigate("/reconServiciosPrevios")}
                  >

                    Volver
                  </button>
                  {}

                  <button
                    id="grabarSolicitudCarrera"
                    className="btn rounded btnPresentar"
                    type="submit"
                    onClick={
                      Object.keys(errors).length === 0
                        ? () => {
                          values.tipo = "borrador";
                        }
                        : () => {
                          setShow({
                            mensaje: true,
                            content:
                              "Debe completar correctamente los datos obligatorios (Datos personales).",
                            tipo: "tituloModal rojo",
                            destinoAviso: null,
                            destinoCerrar: null,
                          });
                        }
                    }
                  // disabled={!params.id && !disablePresentar}
                  >
                    <i className="fa-solid fa-save"></i> Guardar
                  </button>
                </div>
              </Form>
            </>
          )}

        </Formik>
      </>) : (<></>)}
    </div>
    <Footer />
  </>)
}

export default SolicitudReconServiciosPrevios;